const columns = [
  {
    title: '栏目导航',
    href: '#category',
    links: ['娱乐八卦', '情感内幕', '职场爆料', '网红动态'],
  },
  {
    title: '专题板块',
    href: '#topic',
    links: ['选秀生态观察', '直播行业档案', '职场变动记录', '消费避雷指南'],
  },
  {
    title: '标签目录',
    href: '#tags',
    links: ['人物标签', '事件标签', '地区标签', '题材标签'],
  },
  {
    title: '本站说明',
    href: '#faq',
    links: ['使用说明', '更新记录', '常见问题', '目录索引'],
  },
];

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1200px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-[1.3fr_repeat(4,1fr)] md:gap-8">
          <div className="md:pr-6">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-grid-fill text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">黑料网1</span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">
              黑料网1栏目分类清晰，按专题、标签、目录划分不同板块，想找特定类型的料直接按分类进。
            </p>
            <div className="mt-4 flex gap-2">
              {['ri-links-line', 'ri-bookmark-3-line', 'ri-node-tree'].map((icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-600"
                >
                  <i className={`${icon} text-base`}></i>
                </span>
              ))}
            </div>
          </div>

          {columns.map((column) => (
            <div key={column.title}>
              <a
                href={column.href}
                className="font-heading text-sm font-semibold text-foreground-950 transition-colors hover:text-primary-600"
              >
                {column.title}
              </a>
              <ul className="mt-4 flex flex-col gap-2.5">
                {column.links.map((link) => (
                  <li key={link}>
                    <a
                      href={column.href}
                      className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-200 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">
            © 2026 黑料网1 · 栏目分类导航，本站为目录结构演示站点
          </p>
          <p className="text-xs text-foreground-500">
            页面中的栏目、专题、标签与卡片均为示例文案
          </p>
        </div>
      </div>
    </footer>
  );
}